import { FormattedMessage } from 'react-intl';
import { Grid, Typography, Stack } from 'components/ui';
import { GrayCard } from 'components/styles_components/card';
import { CardOptionTypography } from 'components/styles_components/typography';

const PeriodCard = ({ periodNumber, periodCycle, xs = 6, lg = 3 }) => (
  <Grid size={{ xs: xs, lg: lg }}>
    <GrayCard>
      <Stack>
        <CardOptionTypography>
          <FormattedMessage id="inspection.period" />
        </CardOptionTypography>
        <Typography component="span">
          {periodNumber} <FormattedMessage id={`inspection.period.${periodCycle}`} />
        </Typography>
      </Stack>
    </GrayCard>
  </Grid>
);

export default PeriodCard;
